import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../ApiEndpoint";

console.log(BASE_URL ,"BASE_URLBASE_URLBASE_URL");


let initialState = {
    blogdata: [],
    isLoading: false,
    isError: null,
};

//post api
export const addblog = createAsyncThunk("postblog", async (data, { rejectWithValue }) => {
    const { endpoint, payload } = data;
    try {
        const res = await axios.post(BASE_URL + endpoint, payload, { headers: { "Content-Type": "multipart/form-data" } });
        // console.log(res,"blog post api");
        
        return res.data.blog; // Return the response data directly
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});


//Get api
export const getblog = createAsyncThunk("getblog", async ({ endpoint }, { rejectWithValue }) => {
    try {
        let res = await axios.get(BASE_URL + endpoint,);
        // console.log(res.data.blog, "res blog get");
        return res.data.blog;
    } catch (Error) {
        return rejectWithValue(Error.response ? Error.response.data : Error.message);
    }
});

//delete api
export const deleteblog = createAsyncThunk("deleteblog", async (data, { rejectWithValue }) => {
    const { endpoint, uuid } = data;
    // console.log(data ,"delete data");
    
    try {
        await axios.delete(BASE_URL + endpoint + uuid);
        return uuid; // Return the deleted UUID
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});


//updata api 
export const updateblog = createAsyncThunk("updateblog", async (data, { rejectWithValue }) => {
    let { endpoint, uuid, payload } = data;
    try {
        const res = await axios.put(BASE_URL + endpoint + uuid, payload, { headers: { "Content-Type": "multipart/form-data" } });
        console.log(res.data.blog,"updata blog data");
        
        return res.data.blog; 
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});




//slice
export const blogdataSlice = createSlice({
    name: "typedata",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //post method
            .addCase(addblog.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(addblog.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload; 
            })
            .addCase(addblog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blogdata.push(action.payload);
            })
            //get method
            .addCase(getblog.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(getblog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blogdata = action.payload;
            })
            .addCase(getblog.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            //delete method
            .addCase(deleteblog.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(deleteblog.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(deleteblog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blogdata = state.blogdata.filter((item) => item.uuid !== action.payload);
            })
            //updata method
            .addCase(updateblog.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(updateblog.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(updateblog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blogdata = state.blogdata.map((value) => value.uuid === action.payload.uuid ? action.payload : value);
            });

    },
});


export default blogdataSlice.reducer;


